import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';


@Component({
    selector: 'wiz-page-admin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageAdminComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) {}

    public category: string = 'upload';
    public sub: string = 'org';
    public detail: string = '';

    public uploadExpanded: boolean = false;
    public dataExpanded: boolean = false;
    public vectorExpanded: boolean = false;
    public chatbotExpanded: boolean = false;
    public agentExpanded: boolean = false;

    public otherMenus = [
        { value: 'users', label: '사용자 관리', icon: 'users' },
    ];

    private routerSub: any;

    // ─── Toast 상태 (upload 컴포넌트와 공유) ─────────────────
    public toastState: any = {
        show: false,
        phase: 'idle',
        phaseDetail: '',
        message: '',
        progress: 0,
        rowCurrent: 0,
        rowTotal: 0,
        fileIndex: 0,
        fileTotal: 0,
        fileName: '',
    };
    private toastTimeout: any = null;

    public async ngOnInit() {
        await this.service.init();
        // toast 상태에 render 콜백 등록 (upload 컴포넌트에서 호출 가능하도록)
        this.toastState._render = async () => { await this.service.render(); };
        this.toastState._autoDismiss = (delay?: number) => { this._autoDismiss(delay); };

        this.syncFromRoute();

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const beforeCat = this.category;
                const beforeSub = this.sub;
                const beforeDetail = this.detail;
                this.syncFromRoute();
                if (beforeCat !== this.category || beforeSub !== this.sub || beforeDetail !== this.detail) {
                    if (this.category === 'chatbot') {
                        this.chatbotTab = this.sub === 'harness' ? 'harness' : 'basic';
                        if (beforeCat !== 'chatbot') {
                            await this.loadChatbotSettings();
                        }
                    }
                    await this.service.render();
                }
            }
        });

        if (!WizRoute.segment.category) {
            this.service.href('/admin/upload/org');
            return;
        }

        if ((WizRoute.segment.category || 'upload') === 'upload' && !WizRoute.segment.sub) {
            this.service.href('/admin/upload/org');
            return;
        }

        if ((WizRoute.segment.category || '') === 'data' && !WizRoute.segment.sub) {
            this.service.href('/admin/data/org');
            return;
        }

        if ((WizRoute.segment.category || '') === 'vector' && !WizRoute.segment.sub) {
            this.service.href('/admin/vector');
            return;
        }

        if ((WizRoute.segment.category || '') === 'agent' && !WizRoute.segment.sub) {
            this.service.href('/admin/agent/overview');
            return;
        }

        if ((WizRoute.segment.category || '') === 'chatbot' && !WizRoute.segment.sub) {
            this.service.href('/admin/chatbot/basic');
            return;
        }

        if (this.category === 'chatbot') {
            this.chatbotTab = this.sub === 'harness' ? 'harness' : 'basic';
            await this.loadChatbotSettings();
        }

        await this.service.render();
    }

    private syncFromRoute() {
        this.category = WizRoute.segment.category || 'upload';
        this.detail = WizRoute.segment.detail || '';
        this.uploadExpanded = false;
        this.dataExpanded = false;
        this.vectorExpanded = false;
        this.chatbotExpanded = false;
        this.agentExpanded = false;
        if (this.category === 'upload') {
            this.sub = WizRoute.segment.sub || 'org';
            this.uploadExpanded = true;
        } else if (this.category === 'data') {
            this.sub = WizRoute.segment.sub || 'org';
            this.dataExpanded = true;
        } else if (this.category === 'files') {
            this.sub = 'files';
        } else if (this.category === 'vector') {
            this.sub = WizRoute.segment.sub || 'collections';
        } else if (this.category === 'chatbot') {
            this.sub = WizRoute.segment.sub || 'basic';
            this.chatbotExpanded = true;
        } else if (this.category === 'agent') {
            this.sub = WizRoute.segment.sub || 'overview';
            this.agentExpanded = true;
        } else {
            this.sub = '';
        }
    }

    public toggleUpload(event: any) {
        if (event?.stopPropagation) event.stopPropagation();
        this.uploadExpanded = !this.uploadExpanded;
        this.service.render();
    }

    public toggleData(event: any) {
        if (event?.stopPropagation) event.stopPropagation();
        this.dataExpanded = !this.dataExpanded;
        this.service.render();
    }

    public toggleVector(event: any) {
        if (event?.stopPropagation) event.stopPropagation();
        this.vectorExpanded = !this.vectorExpanded;
        this.service.render();
    }

    public toggleChatbot(event: any) {
        if (event?.stopPropagation) event.stopPropagation();
        this.chatbotExpanded = !this.chatbotExpanded;
        this.service.render();
    }

    public toggleAgent(event: any) {
        if (event?.stopPropagation) event.stopPropagation();
        this.agentExpanded = !this.agentExpanded;
        this.service.render();
    }

    public navigate(category: string) {
        if (category === 'upload') {
            this.navigateUpload('org');
            return;
        }
        if (category === 'data') {
            this.navigateData('org');
            return;
        }
        if (category === 'files') {
            this.service.href('/admin/files');
            return;
        }
        if (category === 'vector') {
            this.service.href('/admin/vector');
            return;
        }
        if (category === 'chatbot') {
            this.navigateChatbot('basic');
            return;
        }
        if (category === 'agent') {
            this.navigateAgent('overview');
            return;
        }
        this.service.href(`/admin/${category}`);
    }

    public navigateUpload(sub: string) {
        this.service.href(`/admin/upload/${sub}`);
    }

    public navigateData(sub: string) {
        this.service.href(`/admin/data/${sub}`);
    }

    public navigateVector(sub: string) {
        this.service.href(`/admin/vector/${sub}`);
    }

    public navigateChatbot(sub: string) {
        this.service.href(`/admin/chatbot/${sub}`);
    }

    public navigateAgent(sub: string) {
        this.service.href(`/admin/agent/${sub}`);
    }

    // ─── Toast 제어 ─────────────────────────────────────
    public dismissToast() {
        if (this.toastTimeout) {
            clearTimeout(this.toastTimeout);
            this.toastTimeout = null;
        }
        this.toastState.show = false;
        this.service.render();
    }

    private _autoDismiss(delay: number = 5000) {
        if (this.toastTimeout) {
            clearTimeout(this.toastTimeout);
            this.toastTimeout = null;
        }
        this.toastTimeout = setTimeout(() => {
            this.toastState.show = false;
            this.service.render();
        }, delay);
    }

    // ─── Chatbot Settings ─────────────────────────────
    public chatbotTab: string = 'basic';
    public chatbotSettings: any = {
        llm_provider: 'gemini',
        provider_settings: {
            gemini: { api_key: '', model: 'gemini-2.5-flash-preview-05-20' },
            openai: { api_key: '', model: 'gpt-4o' },
            claude: { api_key: '', model: 'claude-sonnet-4-20250514' },
            ollama: { endpoint: 'http://localhost:11434', model: 'llama3.1', api_key: '' },
        },
        system_prompt: '',
        enabled: true,
        harness: {
            review_enabled: true,
            visualization_enabled: true,
            history_limit: 10,
            keyword_expansion_enabled: true,
            screening_enabled: true,
            retry_search_enabled: true,
            supplement_search_enabled: true,
            recommendation_summary_enabled: true,
            max_retry_queries: 2,
            max_supplement_queries: 3,
        },
    };
    public chatbotSettingsLoading: boolean = false;
    public chatbotSettingsSaving: boolean = false;
    public chatbotSettingsMessage: string = '';
    public chatbotSettingsError: string = '';

    // ─── Skill Editor ─────────────────────────────
    public editingSkill: any = null;
    public showSkillEditor: boolean = false;

    // ─── Tool Editor ─────────────────────────────
    public editingTool: any = null;
    public showToolEditor: boolean = false;

    // ─── Hook Editor ─────────────────────────────
    public editingHook: any = null;
    public showHookEditor: boolean = false;
    public harnessTab: string = 'pipeline';

    public async selectLLMProvider(provider: string) {
        this.chatbotSettings.llm_provider = provider;
        await this.service.render();
    }

    public async loadChatbotSettings() {
        this.chatbotSettingsLoading = true;
        this.chatbotSettingsMessage = '';
        this.chatbotSettingsError = '';
        await this.service.render();
        try {
            const resp = await fetch('/wiz/api/page.admin/chatbot_settings_load', {
                method: 'POST', credentials: 'include'
            });
            const json = await resp.json();
            if (json?.code === 200 && json.data) {
                const defaults = this.chatbotSettings.provider_settings;
                this.chatbotSettings = {
                    ...this.chatbotSettings,
                    ...json.data,
                    provider_settings: {
                        gemini: { ...defaults.gemini, ...(json.data.provider_settings?.gemini || {}) },
                        openai: { ...defaults.openai, ...(json.data.provider_settings?.openai || {}) },
                        claude: { ...defaults.claude, ...(json.data.provider_settings?.claude || {}) },
                        ollama: { ...defaults.ollama, ...(json.data.provider_settings?.ollama || {}) },
                    },
                    harness: {
                        ...this.chatbotSettings.harness,
                        ...(json.data.harness || {}),
                    }
                };
            }
        } catch (e) { }
        this.chatbotSettingsLoading = false;
        await this.service.render();
    }

    public async saveChatbotSettings() {
        this.chatbotSettingsSaving = true;
        this.chatbotSettingsMessage = '';
        this.chatbotSettingsError = '';
        await this.service.render();
        try {
            const params = new URLSearchParams();
            params.set('llm_provider', this.chatbotSettings.llm_provider || 'gemini');
            params.set('provider_settings', JSON.stringify(this.chatbotSettings.provider_settings || {}));
            params.set('system_prompt', this.chatbotSettings.system_prompt || '');
            params.set('enabled', this.chatbotSettings.enabled ? 'true' : 'false');
            params.set('review_enabled', this.chatbotSettings.harness?.review_enabled ? 'true' : 'false');
            params.set('visualization_enabled', this.chatbotSettings.harness?.visualization_enabled ? 'true' : 'false');
            params.set('history_limit', String(this.chatbotSettings.harness?.history_limit || 10));
            params.set('keyword_expansion_enabled', this.chatbotSettings.harness?.keyword_expansion_enabled ? 'true' : 'false');
            params.set('screening_enabled', this.chatbotSettings.harness?.screening_enabled ? 'true' : 'false');
            params.set('retry_search_enabled', this.chatbotSettings.harness?.retry_search_enabled ? 'true' : 'false');
            params.set('supplement_search_enabled', this.chatbotSettings.harness?.supplement_search_enabled ? 'true' : 'false');
            params.set('recommendation_summary_enabled', this.chatbotSettings.harness?.recommendation_summary_enabled ? 'true' : 'false');
            params.set('max_retry_queries', String(this.chatbotSettings.harness?.max_retry_queries || 2));
            params.set('max_supplement_queries', String(this.chatbotSettings.harness?.max_supplement_queries || 3));
            params.set('permission_mode', this.chatbotSettings.permission_mode || 'default');
            params.set('tools', JSON.stringify(this.chatbotSettings.tools || []));
            params.set('hooks', JSON.stringify(this.chatbotSettings.hooks || []));
            const resp = await fetch('/wiz/api/page.admin/chatbot_settings_save', {
                method: 'POST', credentials: 'include',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: params.toString(),
            });
            const json = await resp.json();
            if (json?.code === 200 && json.data) {
                const defaults = this.chatbotSettings.provider_settings;
                this.chatbotSettings = {
                    ...this.chatbotSettings,
                    ...json.data,
                    provider_settings: {
                        gemini: { ...defaults.gemini, ...(json.data.provider_settings?.gemini || {}) },
                        openai: { ...defaults.openai, ...(json.data.provider_settings?.openai || {}) },
                        claude: { ...defaults.claude, ...(json.data.provider_settings?.claude || {}) },
                        ollama: { ...defaults.ollama, ...(json.data.provider_settings?.ollama || {}) },
                    },
                    harness: {
                        ...this.chatbotSettings.harness,
                        ...(json.data.harness || {}),
                    }
                };
                this.chatbotSettingsMessage = '챗봇 설정이 저장되었습니다.';
            } else {
                this.chatbotSettingsError = json?.message || '챗봇 설정 저장에 실패했습니다.';
            }
        } catch (e: any) {
            this.chatbotSettingsError = e?.message || '챗봇 설정 저장 중 오류가 발생했습니다.';
        }
        this.chatbotSettingsSaving = false;
        await this.service.render();
    }

    // ─── Tool / Skill 관리 ─────────────────────────
    public async toggleTool(tool: any) {
        tool.enabled = !tool.enabled;
        await this.service.render();
    }
    public openToolEditor(tool?: any) {
        this.editingTool = tool ? { ...tool } : { id: '', name: '', description: '', category: '커스텀', enabled: true };
        this.showToolEditor = true;
        this.service.render();
    }

    public closeToolEditor() {
        this.showToolEditor = false;
        this.editingTool = null;
        this.service.render();
    }

    public saveTool() {
        if (!this.editingTool?.name) return;
        const tools = this.chatbotSettings.tools || [];
        if (!this.editingTool.id) {
            this.editingTool.id = 'tool_' + Date.now();
            tools.push({ ...this.editingTool });
        } else {
            const idx = tools.findIndex((t: any) => t.id === this.editingTool.id);
            if (idx >= 0) tools[idx] = { ...this.editingTool };
        }
        this.chatbotSettings.tools = tools;
        this.closeToolEditor();
    }

    public deleteTool(toolId: string) {
        if (!confirm('이 도구를 삭제하시겠습니까?')) return;
        this.chatbotSettings.tools = (this.chatbotSettings.tools || []).filter((t: any) => t.id !== toolId);
        this.service.render();
    }

    public openSkillEditor(skill?: any) {
        this.editingSkill = skill ? { ...skill, mcp_tools: [...(skill.mcp_tools || [])] } : { id: '', name: '', description: '', content: '', mcp_tools: [], enabled: true };
        this.showSkillEditor = true;
        this.service.render();
    }

    public closeSkillEditor() {
        this.showSkillEditor = false;
        this.editingSkill = null;
        this.service.render();
    }

    public async saveSkill() {
        if (!this.editingSkill?.name) return;
        try {
            const params = new URLSearchParams();
            params.set('id', this.editingSkill.id || '');
            params.set('name', this.editingSkill.name);
            params.set('description', this.editingSkill.description || '');
            params.set('content', this.editingSkill.content || '');
            params.set('enabled', this.editingSkill.enabled ? 'true' : 'false');
            params.set('mcp_tools', JSON.stringify(this.editingSkill.mcp_tools || []));
            const resp = await fetch('/wiz/api/page.admin/chatbot_skill_save', {
                method: 'POST', credentials: 'include',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: params.toString(),
            });
            const json = await resp.json();
            if (json?.code === 200) {
                await this.loadChatbotSettings();
                this.closeSkillEditor();
            }
        } catch (e) { }
    }

    public async deleteSkill(skillId: string) {
        if (!confirm('이 스킬을 삭제하시겠습니까?')) return;
        try {
            const params = new URLSearchParams();
            params.set('id', skillId);
            const resp = await fetch('/wiz/api/page.admin/chatbot_skill_delete', {
                method: 'POST', credentials: 'include',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: params.toString(),
            });
            const json = await resp.json();
            if (json?.code === 200) {
                await this.loadChatbotSettings();
            }
        } catch (e) { }
    }

    public async toggleSkill(skill: any) {
        skill.enabled = !skill.enabled;
        if (skill.source === 'file') {
            try {
                const params = new URLSearchParams();
                params.set('id', skill.id);
                params.set('name', skill.name);
                params.set('description', skill.description || '');
                params.set('content', skill.content || '');
                params.set('enabled', skill.enabled ? 'true' : 'false');
                params.set('mcp_tools', JSON.stringify(skill.mcp_tools || []));
                await fetch('/wiz/api/page.admin/chatbot_skill_save', {
                    method: 'POST', credentials: 'include',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: params.toString(),
                });
            } catch (e) { }
        }
        await this.service.render();
    }

    public hasFileSkills(): boolean {
        return (this.chatbotSettings.skills || []).some((s: any) => s.source === 'file');
    }

    public isToolSelectedForSkill(toolId: string): boolean {
        return (this.editingSkill?.mcp_tools || []).includes(toolId);
    }

    public getToolName(toolId: string): string {
        const tool = (this.chatbotSettings.tools || []).find((t: any) => t.id === toolId);
        return tool ? tool.name : toolId;
    }

    public toggleSkillMCPTool(toolId: string) {
        if (!this.editingSkill) return;
        if (!this.editingSkill.mcp_tools) this.editingSkill.mcp_tools = [];
        const idx = this.editingSkill.mcp_tools.indexOf(toolId);
        if (idx >= 0) {
            this.editingSkill.mcp_tools.splice(idx, 1);
        } else {
            this.editingSkill.mcp_tools.push(toolId);
        }
        this.service.render();
    }

    // ─── Hook 관리 ─────────────────────────────
    public openHookEditor(hook?: any) {
        this.editingHook = hook ? { ...hook } : { id: '', name: '', event: 'PreToolUse', description: '', action: '', enabled: true };
        this.showHookEditor = true;
        this.service.render();
    }

    public closeHookEditor() {
        this.showHookEditor = false;
        this.editingHook = null;
        this.service.render();
    }

    public async saveHook() {
        if (!this.editingHook?.name) return;
        try {
            const params = new URLSearchParams();
            params.set('id', this.editingHook.id || '');
            params.set('name', this.editingHook.name);
            params.set('event', this.editingHook.event || 'PreToolUse');
            params.set('description', this.editingHook.description || '');
            params.set('action', this.editingHook.action || '');
            params.set('enabled', this.editingHook.enabled ? 'true' : 'false');
            const resp = await fetch('/wiz/api/page.admin/chatbot_hook_save', {
                method: 'POST', credentials: 'include',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: params.toString(),
            });
            const json = await resp.json();
            if (json?.code === 200) {
                await this.loadChatbotSettings();
                this.closeHookEditor();
            }
        } catch (e) { }
    }

    public async deleteHook(hookId: string) {
        if (!confirm('이 훅을 삭제하시겠습니까?')) return;
        try {
            const params = new URLSearchParams();
            params.set('id', hookId);
            const resp = await fetch('/wiz/api/page.admin/chatbot_hook_delete', {
                method: 'POST', credentials: 'include',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: params.toString(),
            });
            const json = await resp.json();
            if (json?.code === 200) {
                await this.loadChatbotSettings();
            }
        } catch (e) { }
    }

    public async toggleHook(hook: any) {
        hook.enabled = !hook.enabled;
        await this.service.render();
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
        if (this.toastTimeout) clearTimeout(this.toastTimeout);
    }
}

export default PageAdminComponent;